import { FormFieldIcon, FormFieldSizeVariant } from "@insite/mobius/FormField";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { RadioStyle } from "@insite/mobius/Radio";
import getColor from "@insite/mobius/utilities/getColor";
import { StoreThemeButtonProps, themeButtonStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { css, ThemeProps } from "styled-components";

// Original interface : ...\mobius\src\FormField\FormField.tsx
interface FormFieldStyleProps extends ThemeProps<BaseTheme> {
    _sizeVariant: FormFieldSizeVariant;
}

export const inputLabelStyles = () => {
    return css`
        margin-right: 0.5em;
        font-size: ${TYPOGRAPHY.size.small};
        font-weight: ${TYPOGRAPHY.weight.bold};
    `;
};

export const inputStyles = () => {
    return css<FormFieldStyleProps>`
        vertical-align: top;

        &:disabled {
            border-color: ${getColor("common.disabledLight")};
            background-color: ${getColor(
                "common.disabledLighter",
            )} !important; /* We don't want to exclude dates picker with this selector input:not(.react-datetime-picker__inputGroup__input) */
            opacity: 1;
            + button ${FormFieldIcon},
            + ${FormFieldIcon} {
                background: transparent;
            }
        }

        ${({ _sizeVariant }) => _sizeVariant ? `
            &:not([aria-describedby]):nth-last-child(2),
            &[aria-describedby]:nth-last-child(3),
            &[role="searchbox"] {
                padding-right: ${sizeVariantValues[_sizeVariant].height - 2}px;
            }
        ` : null};
    `;
};

export const formFieldButtonIconStyles = () => {
    return css`
        &:not(.override) {
            top: 0;
            left: 0;
            background-color: transparent;
            color: inherit;
            transform: scale(1.15);
        }
    `;
};

export const formFieldButtonIconClickableStyles = (themeButtonProps: StoreThemeButtonProps) => {
    return css`
        &:not(.override) {
            ${themeButtonStyles(themeButtonProps)}
            transform: scale(0.85);
        }
    `;
};

export const quantityInputStyles = () => {
    return css`
        width: 45px;
        padding: 0.5em;
        text-align: center;
    `;
};

export const formHorizontalRadioGroupStyles = (spacing = "1em") => {
    return css`
        display: block;
        line-height: ${TYPOGRAPHY.lineHeight.smaller};
        ${RadioStyle} {
            display: inline-block;
            margin-right: ${spacing};

            &:last-child {
                margin-right: 0;
            }

            & + ${RadioStyle} {
                margin-top: 0;
            }
        }
    `;
};

export const formVerticalRadioGroupStyles = (spacing = "0.5em") => {
    return css`
        display: block;

        label {
            font-size: inherit;
        }

        ${RadioStyle} {
            margin-top: ${spacing};
            &:first-child {
                margin-top: 0;
            }
        }
    `;
};
